export enum CEProgressStatus {
	Started = 'Started',
	InProgress = 'InProgress',
	Completed = 'Completed',
}
